// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/traffic_source.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { ListSort, Ownership, Pagination, PaginationMeta, TagRef } from "./common_pb.js";

/**
 * @generated from enum tracker.v1.TrafficSourceKind
 */
export enum TrafficSourceKind {
  /**
   * @generated from enum value: TRAFFIC_SOURCE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRAFFIC_SOURCE_KIND_FACEBOOK_ADS = 1;
   */
  FACEBOOK_ADS = 1,

  /**
   * @generated from enum value: TRAFFIC_SOURCE_KIND_GOOGLE_ADS = 2;
   */
  GOOGLE_ADS = 2,

  /**
   * @generated from enum value: TRAFFIC_SOURCE_KIND_TIKTOK_ADS = 3;
   */
  TIKTOK_ADS = 3,

  /**
   * @generated from enum value: TRAFFIC_SOURCE_KIND_NATIVE = 4;
   */
  NATIVE = 4,

  /**
   * @generated from enum value: TRAFFIC_SOURCE_KIND_PUSH = 5;
   */
  PUSH = 5,

  /**
   * @generated from enum value: TRAFFIC_SOURCE_KIND_SEARCH = 6;
   */
  SEARCH = 6,

  /**
   * @generated from enum value: TRAFFIC_SOURCE_KIND_SEO = 7;
   */
  SEO = 7,

  /**
   * @generated from enum value: TRAFFIC_SOURCE_KIND_EMAIL = 8;
   */
  EMAIL = 8,

  /**
   * @generated from enum value: TRAFFIC_SOURCE_KIND_DIRECT = 9;
   */
  DIRECT = 9,

  /**
   * @generated from enum value: TRAFFIC_SOURCE_KIND_CUSTOM = 10;
   */
  CUSTOM = 10,
}
// Retrieve enum metadata with: proto3.getEnumType(TrafficSourceKind)
proto3.util.setEnumType(TrafficSourceKind, "tracker.v1.TrafficSourceKind", [
  { no: 0, name: "TRAFFIC_SOURCE_KIND_UNSPECIFIED" },
  { no: 1, name: "TRAFFIC_SOURCE_KIND_FACEBOOK_ADS" },
  { no: 2, name: "TRAFFIC_SOURCE_KIND_GOOGLE_ADS" },
  { no: 3, name: "TRAFFIC_SOURCE_KIND_TIKTOK_ADS" },
  { no: 4, name: "TRAFFIC_SOURCE_KIND_NATIVE" },
  { no: 5, name: "TRAFFIC_SOURCE_KIND_PUSH" },
  { no: 6, name: "TRAFFIC_SOURCE_KIND_SEARCH" },
  { no: 7, name: "TRAFFIC_SOURCE_KIND_SEO" },
  { no: 8, name: "TRAFFIC_SOURCE_KIND_EMAIL" },
  { no: 9, name: "TRAFFIC_SOURCE_KIND_DIRECT" },
  { no: 10, name: "TRAFFIC_SOURCE_KIND_CUSTOM" },
]);

/**
 * @generated from enum tracker.v1.TrafficSourceStatus
 */
export enum TrafficSourceStatus {
  /**
   * @generated from enum value: TRAFFIC_SOURCE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRAFFIC_SOURCE_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: TRAFFIC_SOURCE_STATUS_PAUSED = 2;
   */
  PAUSED = 2,

  /**
   * @generated from enum value: TRAFFIC_SOURCE_STATUS_ARCHIVED = 3;
   */
  ARCHIVED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(TrafficSourceStatus)
proto3.util.setEnumType(TrafficSourceStatus, "tracker.v1.TrafficSourceStatus", [
  { no: 0, name: "TRAFFIC_SOURCE_STATUS_UNSPECIFIED" },
  { no: 1, name: "TRAFFIC_SOURCE_STATUS_ACTIVE" },
  { no: 2, name: "TRAFFIC_SOURCE_STATUS_PAUSED" },
  { no: 3, name: "TRAFFIC_SOURCE_STATUS_ARCHIVED" },
]);

/**
 * TrafficSource is a pure source definition: how clicks arrive and how
 * upstream macros project onto the tracker's `trackingField{1..20}`.
 *
 * Domain boundary: the tracker does NOT communicate with ad networks from this
 * aggregate. Credentials, OAuth tokens, cost-sync schedules, and CAPI fanout
 * belong to the Integration aggregate (and to the per-platform services that
 * own those credentials). A TrafficSource row never references an integration.
 *
 * @generated from message tracker.v1.TrafficSource
 */
export class TrafficSource extends Message<TrafficSource> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: tracker.v1.TrafficSourceKind kind = 4;
   */
  kind = TrafficSourceKind.UNSPECIFIED;

  /**
   * @generated from field: string click_url_template = 5;
   */
  clickUrlTemplate = "";

  /**
   * tracking_field_map describes how upstream macros (e.g. `{{ad.id}}`) project
   * onto the tracker's `trackingField{1..20}`. Keys MUST be canonical macros
   * registered in `internal/macro`; values MUST be `trackingField1..20`.
   *
   * @generated from field: map<string, string> tracking_field_map = 7;
   */
  trackingFieldMap: { [key: string]: string } = {};

  /**
   * cost_macros is the set of upstream macros that carry cost data on click
   * (e.g. `cost`, `cpc`). Read by the macro engine to capture ingest-time spend.
   *
   * @generated from field: repeated string cost_macros = 8;
   */
  costMacros: string[] = [];

  /**
   * @generated from field: tracker.v1.TrafficSourceStatus status = 9;
   */
  status = TrafficSourceStatus.UNSPECIFIED;

  /**
   * @generated from field: repeated tracker.v1.TagRef tags = 10;
   */
  tags: TagRef[] = [];

  /**
   * @generated from field: tracker.v1.Ownership ownership = 11;
   */
  ownership?: Ownership;

  /**
   * @generated from field: string created_at = 12;
   */
  createdAt = "";

  /**
   * @generated from field: string updated_at = 13;
   */
  updatedAt = "";

  constructor(data?: PartialMessage<TrafficSource>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.TrafficSource";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "kind", kind: "enum", T: proto3.getEnumType(TrafficSourceKind) },
    { no: 5, name: "click_url_template", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "tracking_field_map", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 8, name: "cost_macros", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "status", kind: "enum", T: proto3.getEnumType(TrafficSourceStatus) },
    { no: 10, name: "tags", kind: "message", T: TagRef, repeated: true },
    { no: 11, name: "ownership", kind: "message", T: Ownership },
    { no: 12, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TrafficSource {
    return new TrafficSource().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TrafficSource {
    return new TrafficSource().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TrafficSource {
    return new TrafficSource().fromJsonString(jsonString, options);
  }

  static equals(a: TrafficSource | PlainMessage<TrafficSource> | undefined, b: TrafficSource | PlainMessage<TrafficSource> | undefined): boolean {
    return proto3.util.equals(TrafficSource, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListTrafficSourcesRequest
 */
export class ListTrafficSourcesRequest extends Message<ListTrafficSourcesRequest> {
  /**
   * @generated from field: tracker.v1.Pagination pagination = 1;
   */
  pagination?: Pagination;

  /**
   * @generated from field: repeated tracker.v1.TrafficSourceKind kinds = 2;
   */
  kinds: TrafficSourceKind[] = [];

  /**
   * @generated from field: repeated tracker.v1.TrafficSourceStatus statuses = 3;
   */
  statuses: TrafficSourceStatus[] = [];

  /**
   * @generated from field: string search = 4;
   */
  search = "";

  /**
   * @generated from field: repeated string tag_ids = 5;
   */
  tagIds: string[] = [];

  /**
   * Sources by their own id.
   *
   * @generated from field: repeated string ids = 6;
   */
  ids: string[] = [];

  /**
   * name | kind | created_at (default: name).
   *
   * @generated from field: tracker.v1.ListSort sort = 7;
   */
  sort?: ListSort;

  constructor(data?: PartialMessage<ListTrafficSourcesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListTrafficSourcesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: Pagination },
    { no: 2, name: "kinds", kind: "enum", T: proto3.getEnumType(TrafficSourceKind), repeated: true },
    { no: 3, name: "statuses", kind: "enum", T: proto3.getEnumType(TrafficSourceStatus), repeated: true },
    { no: 4, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "tag_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "sort", kind: "message", T: ListSort },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListTrafficSourcesRequest {
    return new ListTrafficSourcesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListTrafficSourcesRequest {
    return new ListTrafficSourcesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListTrafficSourcesRequest {
    return new ListTrafficSourcesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListTrafficSourcesRequest | PlainMessage<ListTrafficSourcesRequest> | undefined, b: ListTrafficSourcesRequest | PlainMessage<ListTrafficSourcesRequest> | undefined): boolean {
    return proto3.util.equals(ListTrafficSourcesRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListTrafficSourcesResponse
 */
export class ListTrafficSourcesResponse extends Message<ListTrafficSourcesResponse> {
  /**
   * @generated from field: repeated tracker.v1.TrafficSource items = 1;
   */
  items: TrafficSource[] = [];

  /**
   * @generated from field: tracker.v1.PaginationMeta pagination = 2;
   */
  pagination?: PaginationMeta;

  constructor(data?: PartialMessage<ListTrafficSourcesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListTrafficSourcesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: TrafficSource, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationMeta },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListTrafficSourcesResponse {
    return new ListTrafficSourcesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListTrafficSourcesResponse {
    return new ListTrafficSourcesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListTrafficSourcesResponse {
    return new ListTrafficSourcesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListTrafficSourcesResponse | PlainMessage<ListTrafficSourcesResponse> | undefined, b: ListTrafficSourcesResponse | PlainMessage<ListTrafficSourcesResponse> | undefined): boolean {
    return proto3.util.equals(ListTrafficSourcesResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetTrafficSourceRequest
 */
export class GetTrafficSourceRequest extends Message<GetTrafficSourceRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetTrafficSourceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetTrafficSourceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTrafficSourceRequest {
    return new GetTrafficSourceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTrafficSourceRequest {
    return new GetTrafficSourceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTrafficSourceRequest {
    return new GetTrafficSourceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetTrafficSourceRequest | PlainMessage<GetTrafficSourceRequest> | undefined, b: GetTrafficSourceRequest | PlainMessage<GetTrafficSourceRequest> | undefined): boolean {
    return proto3.util.equals(GetTrafficSourceRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetTrafficSourceResponse
 */
export class GetTrafficSourceResponse extends Message<GetTrafficSourceResponse> {
  /**
   * @generated from field: tracker.v1.TrafficSource traffic_source = 1;
   */
  trafficSource?: TrafficSource;

  constructor(data?: PartialMessage<GetTrafficSourceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetTrafficSourceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "traffic_source", kind: "message", T: TrafficSource },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTrafficSourceResponse {
    return new GetTrafficSourceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTrafficSourceResponse {
    return new GetTrafficSourceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTrafficSourceResponse {
    return new GetTrafficSourceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetTrafficSourceResponse | PlainMessage<GetTrafficSourceResponse> | undefined, b: GetTrafficSourceResponse | PlainMessage<GetTrafficSourceResponse> | undefined): boolean {
    return proto3.util.equals(GetTrafficSourceResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateTrafficSourceRequest
 */
export class CreateTrafficSourceRequest extends Message<CreateTrafficSourceRequest> {
  /**
   * @generated from field: tracker.v1.TrafficSource traffic_source = 1;
   */
  trafficSource?: TrafficSource;

  constructor(data?: PartialMessage<CreateTrafficSourceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateTrafficSourceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "traffic_source", kind: "message", T: TrafficSource },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateTrafficSourceRequest {
    return new CreateTrafficSourceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateTrafficSourceRequest {
    return new CreateTrafficSourceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateTrafficSourceRequest {
    return new CreateTrafficSourceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateTrafficSourceRequest | PlainMessage<CreateTrafficSourceRequest> | undefined, b: CreateTrafficSourceRequest | PlainMessage<CreateTrafficSourceRequest> | undefined): boolean {
    return proto3.util.equals(CreateTrafficSourceRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateTrafficSourceResponse
 */
export class CreateTrafficSourceResponse extends Message<CreateTrafficSourceResponse> {
  /**
   * @generated from field: tracker.v1.TrafficSource traffic_source = 1;
   */
  trafficSource?: TrafficSource;

  constructor(data?: PartialMessage<CreateTrafficSourceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateTrafficSourceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "traffic_source", kind: "message", T: TrafficSource },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateTrafficSourceResponse {
    return new CreateTrafficSourceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateTrafficSourceResponse {
    return new CreateTrafficSourceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateTrafficSourceResponse {
    return new CreateTrafficSourceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateTrafficSourceResponse | PlainMessage<CreateTrafficSourceResponse> | undefined, b: CreateTrafficSourceResponse | PlainMessage<CreateTrafficSourceResponse> | undefined): boolean {
    return proto3.util.equals(CreateTrafficSourceResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateTrafficSourceRequest
 */
export class UpdateTrafficSourceRequest extends Message<UpdateTrafficSourceRequest> {
  /**
   * @generated from field: tracker.v1.TrafficSource traffic_source = 1;
   */
  trafficSource?: TrafficSource;

  constructor(data?: PartialMessage<UpdateTrafficSourceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateTrafficSourceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "traffic_source", kind: "message", T: TrafficSource },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateTrafficSourceRequest {
    return new UpdateTrafficSourceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateTrafficSourceRequest {
    return new UpdateTrafficSourceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateTrafficSourceRequest {
    return new UpdateTrafficSourceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateTrafficSourceRequest | PlainMessage<UpdateTrafficSourceRequest> | undefined, b: UpdateTrafficSourceRequest | PlainMessage<UpdateTrafficSourceRequest> | undefined): boolean {
    return proto3.util.equals(UpdateTrafficSourceRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateTrafficSourceResponse
 */
export class UpdateTrafficSourceResponse extends Message<UpdateTrafficSourceResponse> {
  /**
   * @generated from field: tracker.v1.TrafficSource traffic_source = 1;
   */
  trafficSource?: TrafficSource;

  constructor(data?: PartialMessage<UpdateTrafficSourceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateTrafficSourceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "traffic_source", kind: "message", T: TrafficSource },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateTrafficSourceResponse {
    return new UpdateTrafficSourceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateTrafficSourceResponse {
    return new UpdateTrafficSourceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateTrafficSourceResponse {
    return new UpdateTrafficSourceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateTrafficSourceResponse | PlainMessage<UpdateTrafficSourceResponse> | undefined, b: UpdateTrafficSourceResponse | PlainMessage<UpdateTrafficSourceResponse> | undefined): boolean {
    return proto3.util.equals(UpdateTrafficSourceResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ArchiveTrafficSourceRequest
 */
export class ArchiveTrafficSourceRequest extends Message<ArchiveTrafficSourceRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<ArchiveTrafficSourceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ArchiveTrafficSourceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ArchiveTrafficSourceRequest {
    return new ArchiveTrafficSourceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ArchiveTrafficSourceRequest {
    return new ArchiveTrafficSourceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ArchiveTrafficSourceRequest {
    return new ArchiveTrafficSourceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ArchiveTrafficSourceRequest | PlainMessage<ArchiveTrafficSourceRequest> | undefined, b: ArchiveTrafficSourceRequest | PlainMessage<ArchiveTrafficSourceRequest> | undefined): boolean {
    return proto3.util.equals(ArchiveTrafficSourceRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ArchiveTrafficSourceResponse
 */
export class ArchiveTrafficSourceResponse extends Message<ArchiveTrafficSourceResponse> {
  constructor(data?: PartialMessage<ArchiveTrafficSourceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ArchiveTrafficSourceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ArchiveTrafficSourceResponse {
    return new ArchiveTrafficSourceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ArchiveTrafficSourceResponse {
    return new ArchiveTrafficSourceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ArchiveTrafficSourceResponse {
    return new ArchiveTrafficSourceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ArchiveTrafficSourceResponse | PlainMessage<ArchiveTrafficSourceResponse> | undefined, b: ArchiveTrafficSourceResponse | PlainMessage<ArchiveTrafficSourceResponse> | undefined): boolean {
    return proto3.util.equals(ArchiveTrafficSourceResponse, a, b);
  }
}

